import * as React from 'react'
import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { FormattedDate } from '../atoms/FormattedDate'
import { formatDate } from '@/lib/date'

type Props = {
  children: string
  className?: string
}

export const PublishedDate: React.FC<Props> = (props) => {
  return (
    <time
      css={css`
        color: ${colors.textLight};
        font-size: 14px;
        letter-spacing: 0.02em;
        line-height: 1.5;
      `}
      className={props.className}
      dateTime={formatDate(props.children, 'yyyy-MM-dd')}
      suppressHydrationWarning
    >
      <FormattedDate>{props.children}</FormattedDate>
    </time>
  )
}
